class ShowMoreElements{
    constructor(containerEl, showMoreButton) {
        try {
            this.showMoreContainer = containerEl;
            this.showMoreButton =  showMoreButton;
            
            this.showMoreContainer.forEach(element => {
                this.showMoreList = element.querySelectorAll(".sd-show-more-el");
                this.defaultNbElDisplayed = element.dataset.nbelementbydefault;
            });
            
            if (this.showMoreList.length <= this.defaultNbElDisplayed){
                this.showMoreButton.remove();
            }else{
                this.showMoreList = Array.from(this.showMoreList);
                this.hiddenDepartureEl = this.showMoreList.slice(this.defaultNbElDisplayed);
                this.hiddenDepartureEl.forEach(element => {
                    element.style.display = 'none';
                });
            }
            
            this.showMoreButton.addEventListener("click", this.onClickShowMore);

        }catch (error) {
            console.log(error);
        }
    }
    onClickShowMore = () => {
        const showMoreListHeight = [];

        this.showMoreList.forEach(element => {
             element.style.removeProperty('display');
         });
        
        for (let i = 0; i < this.defaultNbElDisplayed * 2  && i < this.showMoreList.length ; i ++) {
            showMoreListHeight.push(this.showMoreList[i].offsetHeight);
        }
        const sum =  showMoreListHeight.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

        this.showMoreContainer.forEach(element => {
            element.querySelector('.sd-show-more-wrapper').style.height = sum + 'px';
        });

        this.showMoreButton.remove();
    }
}

export default ShowMoreElements;